const form = document.querySelector("#sendsay_form") || false; // сама форма
const popupblackliststyle = `
position:fixed;
overflow: hidden;
top:0;
left:0;
width:100%;
height:100%;
background:rgba(0,0,0,.8);
z-index:999;
display:flex;
justify-content: center;
align-items: center;
opacity:1;
display:flex;
`;
const textdivstyle = `
position:relative;
background:rgb(239, 235, 225);
margin:auto;
width:auto;
padding:25px;
color:#2D2D2B;
`;

if (form) {
    form.onsubmit = function () {
        let ErrorText = "";
        Array.prototype.forEach.call(form.getElementsByClassName("pro_mustbe"), function (el) {
            if (el.type == "checkbox" && !el.checked) {
                fieldName = '"' + el.dataset.text + '"' || "";
                ErrorText += `<li>Не заполнено обязательное поле ${fieldName}<br>`;
            }
            if (el.name == "_member_email") {
                var emailRegExp = /^[a-zA-Z0-9.!\#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                if (!emailRegExp.test(el.value)) {
                    ErrorText += "<li>Почтовый адрес в неверном формате. Проверьте, пожалуйста, <br>";
                }
            }
        });
        if (ErrorText != "") {
            smallAlert(ErrorText);
            form.action = '';
            return false;
        } else if (av.sfTouched) {
            form.action = 'https://sendsay.ru/form/sovremennik/1';
            return true;
        }
    }
}

function smallAlert(text) {
    let popup = document.querySelector(".av-popup") || document.createElement('div');
    popup.className = "av-popup";
    popup.style.cssText = popupblackliststyle;
    popup.innerHTML = `<div style="${textdivstyle}">${text}</div>`;
    document.body.appendChild(popup);
    popup.addEventListener("click", (e) => { popup.style.opacity = 0, setTimeout(() => { popup.style.display = 'none'; document.querySelector("#sendsay_form .email").focus(); }, 250); });
    document.addEventListener("keydown", function (e) {
        if (e.key == "Escape") {
            popup.style.opacity = 0, setTimeout(() => { popup.style.display = 'none'; document.querySelector("#sendsay_form input.email").focus();}, 250);
        }
    });
}
